import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import axios from 'axios';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Auth from '../../modules/Auth.js';
import {setCurrentUser} from '../../actions/Login.js';
import Loading from '../../components/Loading.js';
import Notification from '../../components/Notification.js';
import InvitationForm from './InvitationForm.js';
import General from '../../modules/General';
import Raven from 'raven-js';

class Invite extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			'locked':false,
			'isLoading':true,
			'invitation':false,
			'error':false,
			'firstname':'',
			'lastname':'',
			'didLoad':false,
		}

		this.handleSubmit = this.handleSubmit.bind(this);
	}

	handleSubmit(data) {
		if(this.state.locked) {
			return;
		}
		this.setState({
			locked:true
		});
		axios.put('/invitation/'+this.props.router.location.query.id,data).
		then(res => {
			Notification.success('Success!');

			localStorage.setItem('crallAuthToken',res.data);
			this.props.router.push(this.state.invitation.account_id+'/dashboard');
			this.setState({
				locked:false
			});
		}).catch(err => {
            Raven.captureException(err)
			Notification.error('Error accepting invitation..');
			this.setState({
				locked:false
			});
		});
	}

	componentWillMount() {
		this.start();
	}

	componentDidUpdate() {
		this.start();
	}

	start() {
		if(this.props.auth.isAuthenticated) {
			this.props.router.push(General.Link('/dashboard'));
		}
		if(this.state.didLoad) {
			return;
		}
		this.addBodyClass(true);

		axios.get('/invitation/'+this.props.router.location.query.id).then(res => {
			this.setState({
				'isLoading':false,
				'invitation':res.data,
				'didLoad':true
			});
		}).catch(error => {
			this.setState({
				'isLoading':true,
				'error':true,
				'didLoad':true,
			});
		});
	}

	componentWillUnmount() {
		this.addBodyClass(false);
	}



	addBodyClass(add) {
		if(add) {
			document.body.classList.add('page-login-v3');
			document.body.classList.add('layout-full');
			 
		}else{
			document.body.classList.remove('page-login-v3');
			document.body.classList.remove('layout-full');

		}
	}

	render() {
		if(this.state.isLoading) {
			return (
				<div className="isLoading">
					<div>
						<div style={{position:'absolute',marginLeft:'auto',marginRight:'auto',left:0,right:0}}><img style={{marginTop:'-210px',width:'200px'}} src="/assets/images/logo.png"  /></div>
						{
							this.state.error == true 
							?
							<span><i style={{fontSize:'50px'}} className="icon wb-thumb-down"></i><br /><br />This didn't go as expected. Try refreshing the page..<br />
							<strong>Message:</strong> Invalid invitation.</span>
							:
							<div className="spin2win">
								<div className="double-bounce1"></div>
								<div className="double-bounce2"></div>
								
							</div>
						}
					</div>
				</div>
			)
		}
		return (
			<div className="page vertical-align text-xs-center" data-animsition-in="fade-in" data-animsition-out="fade-out">>
				<div className="page-content vertical-align-middle animation-slide-top animation-duration-1">
					<div className="panel">
						<div className="panel-body">
							<div className="brand">
								<img className="brand-img" style={{width:'100%'}} src="/assets/images/logo.png" alt="..." />
							</div>
							<InvitationForm onSubmit={this.handleSubmit} />
						</div>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		auth:state.auth
	}
}

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({setCurrentUser},dispatch)
}
Invite = connect(mapStateToProps,mapDispatchToProps)(Invite);

export default Invite;


// WEBPACK FOOTER //
// ./containers/login/Invitation.js